module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBzdHJva2U9IiNGRjkyNzUiIHN0cm9rZS13aWR0aD0iMi41ODMiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8cGF0aCBkPSJNMTggOC4ydjEyLjI1TTE4IDguMmw0LjkgNC45TTE4IDguMmwtNC45IDQuOU04LjIgMjcuOGgxOS42Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mb/icon/upload.svg
// module id = B/R2
// module chunks = 30